<template>
  <article class="con_wrap">
    <!-- 日历 -->
    <div class="top_list">
      <div class="list_text" @click="dialogVisible">
        <i></i>
        <span>{{regularDate}}</span>
        <i class="iconfont">&#xe616;</i>
      </div>
      <transition name="calendar-fade">
        <keep-alive>
          <date-picker v-if="datePickerShow" @close="datePickerShow = false" v-model="regularDate"></date-picker>
        </keep-alive>
      </transition>
    </div>
    <div class="report_item_wrapper">
      <!-- 报告标题栏，显示"心电"图标和标题 -->
      <div class="report_header">
        <div class="item_title">
          <i class="iconfont">&#xe6ce;</i>
          <span>{{$t('tag.xindian.title')}}</span>
          <span class="srart_end_time"></span>
        </div>
        <div class="others"></div>
      </div>
      <!--心电数据列表区  使用 v-for 循环渲染多个 ECG 项 
          :ox="item.ox"
          :af="item.af"-->
      <div v-show="ecgShow">
        <v-ecg
          v-for="(item, index) in list"
          :ecgdata="item.ecg"
          :key="index"
          :heart="item.aveRate"
          :time="item.time"
          :id="index"
          :rhythm="item.rhythm"
        ></v-ecg>
        <div class="read part-top">
          <div class="header">
            <i class="iconfont">&#xe61d;</i>
            <h2>{{$t('title.secondaryTitle.xindianReport')}}</h2>
          </div>
          <div class="content">
            <div :class="['article',contentShow ? 'show' : 'hidden']">
              <!--  v-for="(item,index) in content" :key="index" -->
              <p>{{content}}</p>
            </div>
            <div :class="['mask',contentShow ? 'show' : 'hidden']" @click="contentToggle">
              <i class="iconfont" v-show="!contentShow">&#xe632;</i>
              <i class="iconfont" v-show="contentShow">&#xe633;</i>
            </div>
          </div>
        </div>
      </div>
<!-- 无数据时显示的提示 -->
      <div class="noEcgChart" v-show="!ecgShow">
        <p>
          <strong>{{regularDate}}</strong>
          {{$t('tag.xindian.text')}}
        </p>
      </div>
    </div>
  </article>
</template>
<script>
import item from "./item.vue";
import datePicker from "./datePicker";
export default {
  name: "heartEcg",
  props: {
    // 接收父组件传入的时间范围参数
    current: {
      type: String,
      default: ""
    }
  },
  /**
   * 定义响应式数据：
 - list : 心电数据列表
 - datePickerShow : 日历显示状态
 - regularDate : 当前选中日期
 - ecgShow : 是否有数据
 - content : 报告解读内容*/ 
  data() {
    return {
      list: [],
      datePickerShow: false,
      regularDate: "",
      ecgShow: true,
      content: this.$t("ecg.current"),
      contentShow: false,
      appType: {
        appName: this.$route.params.appName
      }
    };
  },
  mounted() {
    
    // 组件挂载时初始化日期
    this.newdate();
    // // 生成模拟心电数据
    // this.generateMockEcgData();
    this.getCurrentDataInfo();//获取心电数据
  },
  methods: {
    // 切换日历弹窗显示
    dialogVisible() {
      this.datePickerShow = true;
    },
    // 获取当前系统日期并格式化
    newdate() {
      let dt = new Date();
      let y = dt.getFullYear();
      let m = dt.getMonth() + 1;
      let d = dt.getDate();
      m = m > 9 ? m : "0" + m;
      this.regularDate = y + "-" + m + "-" + d;
      // console.log(this.regularDate);
    },
    // 构建请求参数并调用 API
    getCurrentDataInfo() {
      let postData = {
        date: this.regularDate,
        userid: this.$route.params.userID,
        friendid: this.$route.params.friendID,
        token: this.$route.params.token,
        current: this.current
      };
      this.$axios
        .getEcg(this.appType, postData)
        .then(this.getCurrentDataInfoSucc);
    },
    /*
    处理 API 返回：
 - code=0 : 数据正常，渲染图表
 - code=999 : 无数据，显示提示
    */ 
    getCurrentDataInfoSucc(res) {
      if (res.code === 0 && res.data) {
        this.ecgShow = true;
        const data = res.data;
        // 转换时间戳为 HH:mm:ss 格式
        this.list = data.map(item => ({
          ...item,
          time: this.formatTime(item.time)
        }));
        // console.log(this.list);
      } else if (res.code === 999) {
        this.ecgShow = false;
      }
    },
    // 时间戳转换为 HH:mm:ss 格式
    formatTime(timestamp) {
      if (!timestamp) return "";
      
      // 判断时间戳是秒还是毫秒
      let ts = timestamp;
      if (timestamp.toString().length === 10) {
        // 秒级时间戳，转毫秒
        ts = timestamp * 1000;
      }
      
      const date = new Date(ts);
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      
      return `${hours}:${minutes}:${seconds}`;
    },
    contentToggle() {
      this.contentShow = !this.contentShow;
    },
    // // 生成包含1000个采样点的模拟心电数据
    // generateMockEcgData() {
    //   const mockData = [];
    //   const sampleCount = 1000;
    //   const heartRate = 72;
    //   const interval = 60 / heartRate;
      
    //   for (let i = 0; i < sampleCount; i++) {
    //     const time = i / 100;
    //     const beatPhase = (time % interval) / interval;
        
    //     let value = 0;
        
    //     if (beatPhase < 0.1) {
    //       // 生成P波（心电图中的第一个波峰）
    //       value = this.generatePWave(beatPhase);
    //     } else if (beatPhase >= 0.1 && beatPhase < 0.15) {
    //       // 生成QRS复合波（心电图中最高的尖峰）
    //       value = this.generateQRSComplex(beatPhase);
    //     } else if (beatPhase >= 0.15 && beatPhase < 0.3) {
    //       // 生成QRS复合波（心电图中最高的尖峰）
    //       value = this.generateTWave(beatPhase);
    //     } else {
    //       // 生成基线噪声
    //       value = this.generateBaselineNoise();
    //     }
        
    //     mockData.push(value);
    //   }
      
    //   this.list = [{
    //     ecg: mockData,
    //     heart: heartRate.toString(),
    //     ox: "98",
    //     af: "",
    //     time: "14:30:25"
    //   this.ecgShow = true;
    // },
    // generatePWave(phase) {
    //   const normalizedPhase = phase / 0.1;
    //   return Math.sin(normalizedPhase * Math.PI) * 0.15 + this.generateNoise();
    // },
    // generateQRSComplex(phase) {
    //   const normalizedPhase = (phase - 0.1) / 0.05;
    //   let value = 0;
      
    //   if (normalizedPhase < 0.3) {
    //     value = -0.4 * (normalizedPhase / 0.3) + this.generateNoise();
    //   } else if (normalizedPhase >= 0.3 && normalizedPhase < 0.5) {
    //     value = 1.2 * Math.sin((normalizedPhase - 0.3) * Math.PI / 0.2) + this.generateNoise();
    //   } else {
    //     value = -0.3 * Math.sin((normalizedPhase - 0.5) * Math.PI / 0.5) + this.generateNoise();
    //   }
      
    //   return value;
    // },
    // generateTWave(phase) {
    //   const normalizedPhase = (phase - 0.15) / 0.15;
    //   return Math.sin(normalizedPhase * Math.PI) * 0.3 + this.generateNoise();
    // },
    // generateBaselineNoise() {
    //   return (Math.random() - 0.5) * 0.06;
    // },
    // // 生成随机噪声
    // generateNoise() {
    //   return (Math.random() - 0.5) * 0.02;
    // }
  },
  components: {
    "v-ecg": item,
    datePicker
  },
  watch: {
    regularDate: function() {
      this.getCurrentDataInfo();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import '~styles/variable.styl';
@import '~styles/global.styl';

.con_wrap {
  width: 100%;
  height: 100%;

  .top_list {
    width: 95%;
    font-size: 0.3rem;
    color: #3696ea;
    box-sizing: border-box;
    padding: 0.3rem 0.86rem;
    margin: 0 auto 0.26rem auto;
    box-shadow: 0 3px 8px rgba(53, 150, 234, 0.27);
    border-radius: 0.1rem;
    background-color: #fff;

    .list_text {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;

      span {
        font-size: 0.3rem;
        font-weight: bold;
      }

      .iconfont {
        font-size: 0.4rem;
      }
    }
  }

  .report_item_wrapper {
    .report_header .item_title .iconfont {
      color: $blueText;
    }

    .noEcgChart {
      margin: 0.4rem 0;
      display: flex;
      justify-content: center;
      align-items: center;

      p {
        font-size: 0.32rem;

        strong {
          font-weight: bold;
        }
      }
    }
  }
}

.read {
  .content {
    position: relative;
    padding: 0 0 0.2rem 0;
    line-height: 0.55rem;

    .mask {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 0.7rem;

      &.hidden {
        background: rgba(255, 255, 255, 0.9);
      }

      &.show {
        background: rgba(255, 255, 255, 1);
      }

      .iconfont {
        margin-top: 0.02rem;
        display: block;
        font-size: 0.48rem;
        color: #333;
      }
    }

    h3 {
      margin-bottom: 0.1rem;
      font-size: 0.3rem;
      font-weight: bold;
    }

    .article {
      text-indent: 0.6rem;
      text-align: justify;
      color: #707070;

      &.hidden {
        height: 1.4rem;
        overflow: hidden;
      }

      &.show {
        margin-bottom: 0.7rem;
        height: auto;
        overflow: auto;
      }
    }
  }
}

.part-top {
  margin: 0.6rem 0 0.4rem;

  .header {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    margin-bottom: 0.2rem;

    .iconfont {
      margin: 0 0.1rem 0;
      font-size: 0.4rem;
      color: $blueText;
    }

    h2 {
      font-size: 0.36rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ecg/ecg.vue